import { Component } from "@angular/core";
import { RouterService } from "src/app/services/router/router.service";

@Component({
  selector: 'header-home-button',
  template: `
    <div class="button-wrapper" (click)="onClickButton()">
      <i class="fas fa-house"></i>
    </div>
  `,
  styles: [`
    .button-wrapper {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 2.5rem;
      height: 2.5rem;
    }
    i {
      color: var(--white);
      font-size: 1.25rem;
      font-weight: 900;
      line-height: 140%;
    }
  `],
})
export class HeaderHomeButtonComponent {
  constructor(private routerService: RouterService) {
  }

  onClickButton(): void {
    this.routerService.navigate('');
  }
}